import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import {
	StyledCurrentLevelContainer,
	StyledLevelContainer,
	StyledSvg,
} from './AppTruckJobMyLevel.styled';

const AppTruckJobMyLevel = () => {
	const levelProgress = 0.4;
	const levelCircle = useMemo(() => 157 - 157 * levelProgress, [levelProgress]);

	return (
		<StyledCurrentLevelContainer>
			<StyledLevelContainer>
				<StyledSvg>
					<circle
						cx="30"
						cy="30"
						r="25"
						stroke="#ffffff"
						strokeWidth="5"
						fill="none"
						opacity={0.1}
					/>
					<circle
						cx="30"
						cy="30"
						r="25"
						className="indicator"
						stroke="#1AB248"
						strokeWidth="5"
						fill="none"
						strokeLinecap="round"
						strokeDasharray={157}
						strokeDashoffset={levelCircle}
					/>
				</StyledSvg>
				<Text>4</Text>
			</StyledLevelContainer>
			<div>
				<Text style={{ fontSize: 12, color: '#ffffff', opacity: 0.5 }}>
					Текущий уровень
				</Text>
				<Text
					style={{
						fontSize: 14,
						fontWeight: 500,
						color: '#ffffff',
						marginTop: 4,
					}}
				>
					XP 14 000{' '}
					<span style={{ fontSize: 12, fontWeight: 400, opacity: 0.5 }}>
						/ 40 000
					</span>
				</Text>
			</div>
		</StyledCurrentLevelContainer>
	);
};

export { AppTruckJobMyLevel };
